/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-north-1",
    "aws_cognito_identity_pool_id": "eu-north-1:1c70176c-651b-4823-bb86-06bcae430097",
    "aws_cognito_region": "eu-north-1",
    "aws_user_pools_id": "eu-north-1_n51udS5HS",
    "aws_user_pools_web_client_id": "h3534d7a6dj3bpbalmb5sd76q",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-north-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "owners-prod",
            "region": "eu-north-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "owners",
            "endpoint": "https://rklhbi2deh.execute-api.eu-north-1.amazonaws.com/prod",
            "region": "eu-north-1"
        }
    ]
};


export default awsmobile;
